import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=f16959b6&scoped=true&"
import script from "./Actions.vue?vue&type=script&lang=ts&"
export * from "./Actions.vue?vue&type=script&lang=ts&"
import style0 from "./Actions.vue?vue&type=style&index=0&id=f16959b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16959b6",
  null
  
)

export default component.exports